<h2 mat-dialog-title data-test="dialog">{{ data.title }}</h2>
<div mat-dialog-content class="spacing-margins">
  <agr-form [formGroup]="formGroup">
    <div class="spacing--margin-vertical">
      <agr-extended-notification
        notificationType="info"
        [title]="'flock-overview.week-registrations.upload-csv-notification' | translate"
        [message]="'flock-overview.week-registrations.upload-csv-message' | translate"
      ></agr-extended-notification>
    </div>
    <div>
      <mat-form-field class="spacing--margin-top">
        <mat-label>{{
          'flock-overview.week-registrations.weekregistration-select-interval-type' | translate
        }}</mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          formControlName="intervalTypeControl"
          placeholder="{{
            'flock-overview.week-registrations.weekregistration-select-interval-type' | translate
          }}"
          data-test="select-interval-type"
        >
          <mat-option
            *ngFor="let intervalType of intervalTypes"
            [value]="intervalType"
            data-test="intervalTypes-item"
          >
            {{ 'flock-overview.week-registrations.interval-type-' + intervalType | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="spacing--margin-bottom">
      <button type="button" mat-stroked-button (click)="file.click()" data-test="file-button">
        {{
          selectedFile
            ? selectedFile.name
            : ('flock-overview.week-registrations.weekregistration-select-file' | translate)
        }}
      </button>
    </div>
    <input
      hidden
      (change)="onFileSelected()"
      #file
      type="file"
      accept=".csv"
      data-test="file-input"
    />
  </agr-form>
</div>

<div class="dialog-buttons" mat-dialog-actions data-test="dialogButtons">
  <button
    mat-flat-button
    color="primary"
    [disabled]="!selectedFile"
    (click)="
      confirm({
        file: selectedFile,
        intervalType: formGroup.get('intervalTypeControl')?.value,
        weekRegistrations: this.data.flock.weekRegistrations,
      })
    "
    data-test="dialog-submit"
  >
    {{ data.confirmButtonText }}
  </button>
  <button mat-stroked-button class="cancel-button" data-test="dialog-cancel" (click)="cancel()">
    {{ data.cancelButtonText }}
  </button>
</div>
